import { render, staticRenderFns } from "./attraction.vue?vue&type=template&id=b0f0d6fc"
import script from "./attraction.vue?vue&type=script&lang=js"
export * from "./attraction.vue?vue&type=script&lang=js"
import style0 from "./attraction.vue?vue&type=style&index=0&id=b0f0d6fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports